import React, { useState } from "react";
import {
    Navigate } from 'react-router-dom';
import {
  getAuthSession
} from "../../constants/constant";
import LoginPage from "./LoginPage";
//import SsoLogin from "./SsoLogin";

const Login = () => {
  const [isSubmitted, setIsSubmitted] = useState(getAuthSession().loggedIn);

  const submitForm = () => {
    setIsSubmitted(true);
  };
  return (
    <>{
        !isSubmitted ? <LoginPage submitForm={submitForm} /> : <Navigate replace to="/dashboard" />}</>
  );
};

export default Login;
